export const searchSettingsForLesson = {
  limit: 15,
  offset: 0,
};

export const searchSettingsForLessonParticipant = {
  limit: 20,
  offset: 0,
};
